export function getStringFromDate(time: Date | null) {
  return `${time?.getHours().toString().padStart(2, "0")}:${time
    ?.getMinutes()
    .toString()
    .padStart(2, "0")}`;
}
